import axios from "axios";

const state = () => ({
  errors: [],
  loading: false,
  regions: [],
});

const mutations = {
  SET_ERRORS(state, errors) {
    state.errors = errors;
  },
  CLEAR_ERRORS(state) {
    state.errors = [];
  },
  SET_LOADING(state) {
    state.loading = true;
  },
  CLEAR_LOADING(state) {
    state.loading = false;
  },
  SET_REGIONS(state, data) {
    state.regions = data;
  },
};

const getters = {
  getErrors: (state) => {
    return state.errors;
  },
  isLoading: (state) => {
    return state.loading;
  },
  getRegionsList: (state) => {
    return state.regions;
  },
};

const actions = {
  async fetchRegions({ commit }) {
    commit("SET_LOADING");
    const url = process.env.VUE_APP_API_URL + "/tm/regions";
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
    };
    try {
      const response = await axios.get(url, config);
      commit("SET_REGIONS", response.data.data);
      commit("CLEAR_LOADING");
    } catch (error) {
      console.log(error);
      commit("CLEAR_LOADING");
      commit(
        "SET_ERRORS",
        error.response?.data?.message || "Fetch Regions failed"
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
